export default __webpack_public_path__ + "static/media/featSportBg.0d961714.png";